import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { ReportHelpersService } from 'src/app/services/report-helpers/report-helpers.service';
import { TimeTrackingPrintReportComponent } from './time-tracking-print-report/time-tracking-print-report.component';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';

export function getReportRequest(reportHelpersService: ReportHelpersService, transition: Transition) {
    const params = transition.params();
    const { userID, startDate, endDate, timeType, type, perms, showDetails } = params;
    return reportHelpersService.getReportRequest({ userID, startDate, endDate, timeType, type, 
        perms, showDetails, shouldGetAll: true });
}

export function resolveReportContent(reportHelpersService: ReportHelpersService, reportsService: ReportsService, transition: Transition) {
    const request = getReportRequest(reportHelpersService, transition);
    return reportsService
        .getTimeReport(request)
        .toPromise();
}

export let TimeTrackingReportStates: Ng2StateDeclaration[] = [{
    name: 'print.reports',
    url: '/reports',
    abstract: true
},{
    name: 'print.reports.timeTracking',
    url: '/time-tracking/paraeducator?userID&startDate&endDate&type&perms&showDetails&timeType',
    views: {
        'content@print': {
            component: TimeTrackingPrintReportComponent
        }
    },
    params: {
        type: {
            type: 'int'
        },
        perms: {
            type: 'int'
        },
        timeType: {
            type: 'int',
            value: TimeTrackingTypes.ACT48
        }
    },
    resolve: [{
        token: 'pagedResponse',
        deps: [ReportHelpersService, ReportsService, Transition],
        resolveFn: resolveReportContent,
    },
    {
        token: 'request',
        deps: [ReportHelpersService, Transition],
        resolveFn: getReportRequest
    }]
}];